module.exports = __webpack_public_path__ + "img/restaurant-banner2.8c1c4902.jpeg";